import React, { useRef, useState, useEffect } from 'react';
import ReactPlayer from 'react-player';
import dayjs from 'dayjs';
import { sendVideoAnalytics } from '../../Store/actions/common.actions';
import { useMobileOrientation } from 'react-device-detect';
import { useTracker } from '../../TrackerFolder/TrackerComponent';

let tracking_data = {
  content_id: '',
  content_type: '',
  start_time: '',
  end_time: '',
  video_duration: '',
  seekbar_change: [],
  progress: [],
  max_view_duration: ''
};

let progressData = {
  step: []
};

let step_counter = 0;
export default function VideoPlayer({ data, maxViewDuration, videoRef, customClass }) {
  const playerRef = useRef(null);
  const videoDetailsParent = useRef();
  const prevCountRef = useRef();
  const { isLandscape } = useMobileOrientation();
  const [aspectVideoContainerSize, setAspectVideoContainerSize] = useState('0px');
  const [currentTime, setCurrentTime] = useState(0.0);
  const [duration, setDuration] = useState(0.0);

  const [videoUrl, setvideoUrl] = useState('');
  const [videoPlayerControl, setvideoPlayerControl] = useState(true);
  const [videoPlay, setvideoPlay] = useState(true);
  const [progressStep, setProgressStep] = useState(0);
  const [contentType, setContentType] = useState('');
  const [contentId, setContentId] = useState(0);

  const PROGRESS_INTERVAL = 5000;
  const DATA_DESIMAL_POINT = 2;
  const timeFormat = 'YYYY-MM-DD HH:mm:ss';
  const getCurrentTime = () => dayjs(new Date().getTime()).format(timeFormat);

  const onReady = React.useCallback(() => {
    if (data?.playedTime) {
      console.log('===>>', data?.playedTime);
      const timeToStart = data?.playedTime;
      playerRef.current.seekTo(timeToStart, 'seconds');
    }
  }, [data, playerRef.current]);

  useEffect(() => {
    // videoRef.current = trackData;
    setvideoUrl(data.src);

    setContentType(data.content_type);
    setContentId(data.content_id);
    tracking_data.content_id = data.content_id ? data.content_id : 0;
    tracking_data.content_type = data.content_type ? data.content_type : 'not found';

    return () => {};
  }, [data]);

  useEffect(() => {
    //assign the ref's current value to the count Hook
    prevCountRef.current = currentTime;
  }, [currentTime]); //run this code when the value of count changes

  useEffect(() => {
    return () => {
      if (tracking_data) {
        tracking_data.play_time = prevCountRef.current;
        tracking_data.end_time = getCurrentTime();
        sendVideoAnalytics(tracking_data);
      }
    };
  }, []);
  useEffect(() => {
    setVideoConatinerSize();
  }, [isLandscape]);

  const recordActivity = () => {
    let user_action = {};
    user_action['step' + step_counter] = [...progressData.step];
    tracking_data.progress.push(user_action);
    progressData.step = [];
    step_counter += 1;
  };

  const handleStart = (e) => {
    // e.preventDefault();
    let tempDuration = duration / 60;
    tracking_data.video_duration = tempDuration.toFixed(DATA_DESIMAL_POINT);
    tracking_data.start_time = getCurrentTime();

    let temp_duration = currentTime / 60;
    temp_duration = temp_duration.toFixed(DATA_DESIMAL_POINT);
    let startTrackObj = {
      timestamp: getCurrentTime(),
      event: 'video_play_started',
      current_video_duration: temp_duration ?? ''
    };

    progressData.step.push(startTrackObj);
    recordActivity();
  };

  const handleEnablePIP = () => {
    console.log('onEnablePIP');
  };

  const handleDisablePIP = () => {
    console.log('onDisablePIP');
  };

  const handleSeekMouseDown = (e) => {
    console.log('handleSeekMouseDown');
    // this.setState({ seeking: true })
  };

  const handleSeekChange = (e) => {
    console.log('seeek change.........||||||||||' + e);
    let tempFrom = currentTime / 60;
    let tempTo = e / 60;
    let seekTrackObj = {
      timestamp: getCurrentTime(),
      from: tempFrom.toFixed(DATA_DESIMAL_POINT),
      to: tempTo.toFixed(DATA_DESIMAL_POINT)
    };
    console.log(tempFrom + 'seeek change.........' + tempTo);
    tracking_data.seekbar_change.push(seekTrackObj);
    console.table(tracking_data.seekbar_change);
    recordActivity();
  };

  const handleProgress = (e) => {
    setCurrentTime(e.playedSeconds);

    if (tracking_data.max_view_duration < currentTime / 60) {
      let tempCurrentTime = currentTime / 60;
      tracking_data.max_view_duration = tempCurrentTime.toFixed(DATA_DESIMAL_POINT);
      if (typeof maxViewDuration == 'function') {
        maxViewDuration(tempCurrentTime.toFixed(DATA_DESIMAL_POINT));
      }
    }

    let progressTrackObj = {
      timestamp: getCurrentTime(),
      progressDetails: JSON.stringify(e)
    };
    progressData.step.push(progressTrackObj);
    recordActivity();

    // console.log("Progress::\n", JSON.stringify(tracking_data));
  };

  const handleVideoEnd = (e) => {
    tracking_data.end_time = getCurrentTime();
  };

  const handleReady = () => {
    let temp_duration = currentTime / 60;
    temp_duration = temp_duration.toFixed(DATA_DESIMAL_POINT);
    let readyTrackObj = {
      timestamp: getCurrentTime(),
      event: 'video_loaded_on_player',
      current_video_duration: temp_duration ?? ''
    };

    progressData.step.push(readyTrackObj);
    recordActivity();
  };

  const handlePlay = () => {
    let temp_duration = currentTime / 60;
    temp_duration = temp_duration.toFixed(DATA_DESIMAL_POINT);
    let playTrackObj = {
      timestamp: getCurrentTime(),
      event: 'video_play',
      current_video_duration: temp_duration ?? ''
    };

    progressData.step.push(playTrackObj);
    recordActivity();

    setvideoPlay(true);
  };

  const handlePause = () => {
    let temp_duration = currentTime / 60;
    temp_duration = temp_duration.toFixed(DATA_DESIMAL_POINT);
    let pauseTrackObj = {
      timestamp: getCurrentTime(),
      event: 'video_pause',
      current_video_duration: temp_duration ?? ''
    };

    progressData.step.push(pauseTrackObj);
    recordActivity();

    setvideoPlay(false);
  };

  const handleOnBuffer = (e) => {
    let temp_duration = currentTime / 60;
    temp_duration = temp_duration.toFixed(DATA_DESIMAL_POINT);
    let bufferTrackObj = {
      timestamp: getCurrentTime(),
      buffer_start: 'Buffering Started',
      current_video_duration: temp_duration ?? ''
    };
    progressData.step.push(bufferTrackObj);
    recordActivity();
  };

  const handleOnBufferEnd = (e) => {
    let temp_duration = currentTime / 60;
    temp_duration = temp_duration.toFixed(DATA_DESIMAL_POINT);
    let bufferTrackObj = {
      timestamp: getCurrentTime(),
      buffer_end: 'Buffering Ended',
      current_video_duration: temp_duration ?? ''
    };

    progressData.step.push(bufferTrackObj);
    recordActivity();
  };

  const handleOnError = (e) => {
    let errorTrackObj = {
      timestamp: getCurrentTime(),
      error: JSON.stringify(e)
    };

    progressData.step.push(errorTrackObj);
    recordActivity();
  };

  const setVideoConatinerSize = () => {
    if (videoDetailsParent.current) {
      const videoDivWidth = videoDetailsParent.current ? videoDetailsParent.current.clientWidth : 0;
      const aspectWidth = videoDivWidth / 1.7786;
      setAspectVideoContainerSize(aspectWidth > 0 ? Math.round(aspectWidth) : 0);
      console.log('aspect size is' + aspectWidth);
    }
  };

  return (
    <div ref={videoDetailsParent} style={{ height: `${aspectVideoContainerSize}px` }}>
      <ReactPlayer
        className={customClass ?? 'reactVideoPlayerDtls'}
        ref={playerRef}
        width="100%"
        height={`100%`}
        controls={videoPlayerControl}
        playing={videoPlay}
        url={videoUrl}
        onReady={() => {
          handleReady();
          data?.playedTime && onReady();
        }}
        onStart={handleStart}
        onPlay={handlePlay}
        onEnablePIP={handleEnablePIP}
        onDisablePIP={handleDisablePIP}
        onPause={handlePause}
        onBuffer={handleOnBuffer}
        onBufferEnd={handleOnBufferEnd}
        onSeek={(e) => handleSeekChange(e)}
        onEnded={handleVideoEnd}
        onError={handleOnError}
        onProgress={handleProgress}
        progressInterval={PROGRESS_INTERVAL}
        onDuration={(e) => {
          setDuration(e);
        }}
        playsinline={true}
        vimeoConfig={{
          iframeParams: { fullscreen: 0 }
        }}
      />
    </div>
  );
}
